import React from 'react';

function FormSelect({ 
    label, 
    field, 
    value, 
    options, 
    dispatch, 
    tooltip = '',
    title = '',
    actionType = 'UPDATE_FIELD',
    index,
    subField,
    placeholder = "Select an option",
    required = false,
    disabled = false,
    className = ''
}) {
    const handleChange = (e) => {
        if (actionType === 'UPDATE_LINE_ITEM_FIELD') {
            // For line items, we need to provide the index and the field within that line item
            dispatch({ 
                type: actionType, // Make sure this matches the case in the reducer
                index: index, 
                field: subField, 
                value: e.target.value 
            });
        } else {
            // For regular fields, just provide the field name and value
            dispatch({ 
                type: actionType, 
                field, 
                value: e.target.value 
            });
        }
    };

    // Ensure options is an array, even if it's null or undefined
    const safeOptions = Array.isArray(options) ? options : [];
    
    return (
        <div className={`form-group ${className}`}>
            <label htmlFor={field} className="form-label">
                {label}
                {required && <span className="required-indicator">*</span>}
                {tooltip && (
                    <div className="tooltip-container">
                        <span className="tooltip-icon">ⓘ</span>
                        <span className="tooltip-text">{tooltip}</span>
                    </div>
                )}
            </label>
            <select
                id={field}
                name={field}
                value={value ?? ''}
                onChange={handleChange}
                required={required}
                disabled={disabled}
                title={title || undefined}
                className={`form-select ${value ? '' : 'placeholder-selected'}`}
            >
                <option value="" disabled>
                    {placeholder}
                </option>
                {safeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label || option.value}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default FormSelect;
